document.addEventListener('DOMContentLoaded', () => {
  const updateBadges = () => {
    const features = document.querySelectorAll('.filming-card__features');

    features.forEach((feature) => {
      const badges = feature.querySelectorAll('.badge__wrapper');

      let badgeMore = feature.querySelector('.filming-card__badge-more');
      if (badgeMore) {
        badgeMore.remove();
      }

      if (window.innerWidth <= 575) {
        if (badges.length > 1) {
          for (let i = 1; i < badges.length; i++) {
            badges[i].classList.add('hidden');
          }

          const hiddenCount = badges.length - 1;
          badgeMore = document.createElement('div');
          badgeMore.className = 'filming-card__badge-more';
          badgeMore.textContent = `+${hiddenCount}`;
          feature.appendChild(badgeMore);
        }
      } else {
        for (let i = 1; i < badges.length; i++) {
          badges[i].classList.remove('hidden');
        }
      }
    });
  };

  updateBadges();

  window.addEventListener('resize', updateBadges);
});
